import React, { useEffect, useState } from "react";
import axios from "axios";
import "./App.css";
import { capitalizeSentence } from "./utils";
import WeatherHolder from "./components/WeatherHolder";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const [state, setState] = useState({
    currentWeather: {},
    fiveDayForecast: [],
    input: "London", // default city name
  });

  const userLocation = (e) => {
    if (e.key === "Enter") {
      getApiData();
    }
    setState({ ...state, input: e.target.value });
  };

  const getApiData = async () => {
    try {
      // Fetch current weather data
      const weatherResponse = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${state.input}&appid=b2b1d37a03db33782eaa23bb89a9e686&units=metric`
      );

      // Fetch 5-day forecast data using the coordinates from the current weather data
      const { lat, lon } = weatherResponse.data.coord; // Get latitude and longitude
      const forecastResponse = await axios.get(
        `https://api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${lon}&appid=b2b1d37a03db33782eaa23bb89a9e686&units=metric`
      );

      // Set both current weather and forecast data in state
      setState({
        ...state,
        currentWeather: weatherResponse.data,
        fiveDayForecast: forecastResponse.data.list,
      });
    } catch (error) {
      toast.error("Your search result is not valid or city not found.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    getApiData(); // Fetch data when the component mounts
    const interval = setInterval(() => {
      getApiData(); // Fetch data every hour
    }, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (!state.currentWeather.main) {
    return <p>Waiting for data...</p>;
  }

  const date = new Date();

  return (
    <>
      <ToastContainer />
      <div className="title">
        <h2>Current Weather</h2>
      </div>
      <div className="header">
        <h2>Location: {capitalizeSentence(state.input)}</h2>
      </div>

      <div className="input-holder">
        <input
          className="location-input"
          type="text"
          onKeyUp={(e) => {
            userLocation(e);
          }}
          placeholder="Enter Location:"
        />
      </div>

      <div className="today">
        <WeatherHolder
          date={date}
          image={state.currentWeather.weather[0].icon}
          temp={Math.round(state.currentWeather.main.temp)}
          description={capitalizeSentence(
            state.currentWeather.weather[0].description
          )}
          wind={state.currentWeather.wind.speed}
          humidity={state.currentWeather.main.humidity}
          pressure={state.currentWeather.main.pressure}
        />
      </div>

      <div className="forecast">
        {state.fiveDayForecast.length > 0 &&
          state.fiveDayForecast
            .filter((reading) => reading.dt_txt.includes("12:00:00")) // Filter to show forecasts at noon
            .map((day, index) => {
              const forecastDate = new Date(day.dt * 1000);
              return (
                <div key={index} className="forecast-cards card">
                  <WeatherHolder
                    image={day.weather[0].icon}
                    date={forecastDate}
                    temp={Math.round(day.main.temp)}
                    description={capitalizeSentence(day.weather[0].description)}
                    wind={day.wind.speed}
                    humidity={day.main.humidity}
                    pressure={day.main.pressure}
                  />
                </div>
              );
            })}
      </div>
    </>
  );
};

export default App;
